module.exports = __webpack_public_path__ + "static/media/momos.b962e93c.webp";